<template>
  <div class="dizme_tm_section" id="home">
    <div class="dizme_tm_hero">
      <div
        class="background"
        :data-img-url="`/img/slider/${dark ? 2 : 1}.jpg`"
      ></div>
      <div class="container">
        <div class="content">
          <div class="details">
            <div class="hello">
              <h3 class="orangeText">Welcome to</h3>
            </div>
            <div class="name">
              <h3>MyPBE</h3>
            </div>
            <div class="job">
              <p>
                <span class="greenText">Supercharging</span> Your
                <span class="purpleText">PBE</span> Preparation
              </p>
            </div>
            <div class="button hero-buttons">
              <div class="demo-button">
                <a class="anchor" href="https://app.mypbe.com/demo">
                  <span>🚀 Try the Demo</span>
                </a>
              </div>
              <div class="signup-button mobile-only">
                <a class="anchor" href="https://app.mypbe.com/register">
                  <span>Get Started — It's Free</span>
                </a>
              </div>
              <div class="hero-secondary">
                <div class="video-button">
                  <a class="anchor" @click="openVideoPopup()">
                    <span>
                      What's MyPBE? <img src="/img/slider/play.png" width="25px;" alt="play" />
                    </span>
                  </a>
                </div>
                <a class="login-link mobile-only" href="https://app.mypbe.com/login">Log in</a>
              </div>
              <VideoPopup :show="isVideoPopupVisible" :videoUrl="videoUrl" @close="isVideoPopupVisible = false" />
            </div>
            <!-- <div class="social">
                <ul>
                  <li>
                    <a href="#"><i class="icon-facebook-1"></i></a>
                  </li>
                  <li>
                    <a href="#"><i class="icon-twitter-1"></i></a>
                  </li>
                  <li>
                    <a href="#"><i class="icon-linkedin-1"></i></a>
                  </li>
                  <li>
                    <a href="#"><i class="icon-behance"></i></a>
                  </li>
                </ul>
            </div> -->
          </div>
          <div class="avatar">
            <div class="image">
              <img :src="`/img/slider/mypbe-avatar-${imgIndex}.webp`" alt="" />
              <!-- <span
                class="skills illustrator anim_moveBottom"
                v-html="ai"
              ></span>
              <span class="skills photoshop anim_moveBottom" v-html="ps"></span>
              <span class="skills figma anim_moveBottom" v-html="figma"></span> -->
            </div>
          </div>
        </div>
      </div>
      <div class="dizme_tm_down non-mobile-only">
        <a class="anchor" href="#process" v-html="dark ? mouseDark : mouse">
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { ai, figma, mouse, mouseDark, ps } from "../svg";
import VideoPopup from "./popup/VideoPopup.vue";

export default {
  name: "HomeComponent",
  data() {
    return {
      ai,
      ps,
      figma,
      mouse,
      mouseDark,
      imgIndex: Math.floor(Math.random() * 3) + 1,
      isVideoPopupVisible: false,
      videoUrl: "https://www.youtube.com/embed/0hd2wavZWwk?si=iV4FoDbgFEBiBlw9",
    };
  },
  methods: {
    openVideoPopup() {
      this.isVideoPopupVisible = true;
    },
    closeVideoPopup() {
      this.isVideoPopupVisible = false;
    },
  },
  props: {
    dark: { type: Boolean },
  },
  components: {
    VideoPopup
  },
};
</script>

<style scoped>

.dizme_tm_button a{
  padding: 10px 30px 10px 30px;
}

.hero-buttons {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.demo-button a {
  text-decoration: none;
  display: inline-block;
  font-family: 'Jost', sans-serif;
  font-weight: 600;
  border-radius: 50px;
  border: none;
  padding: 12px 32px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #d73d1a 0%, #f75023 50%, #ff6b35 100%);
  color: #fff;
  box-shadow: 0 8px 25px rgba(247, 80, 35, 0.35);
  transition: all 0.3s ease;
}

.demo-button a span {
  position: relative;
  z-index: 2;
  color: #fff;
}

.demo-button a:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 35px rgba(247, 80, 35, 0.45);
}


.video-button a{
	text-decoration: none;
	color: #fff;
	display: inline-block;
	font-family: 'Jost', sans-serif;
	font-weight: 500;
	border-radius: 50px;
	border: 2px solid #1cbe59;
	padding: 7px 10px 7px 10px;
	position: relative;
	overflow: hidden;
}

.video-button span{
	position: relative;
	z-index: 2;
	
	-webkit-transition: all .3s ease;
  -moz-transition: all .3s ease;
  -ms-transition: all .3s ease;
  -o-transition: all .3s ease;
  transition: all .3s ease;
}
.video-button a:before{
	position: absolute;
	content: "";
	z-index: 0;
	background-color: #1cbe59;
	left: -5px;
	right: -5px;
	bottom: -5px;
	height: 110%;
	
	-webkit-transition: all .3s ease;
  -moz-transition: all .3s ease;
  -ms-transition: all .3s ease;
  -o-transition: all .3s ease;
  transition: all .3s ease;
}
.video-button a:hover:before{
	height: 0;
}
.video-button a:hover span{
	color: #000;
}

.hero-secondary {
  display: flex;
  align-items: center;
  gap: 18px;
}

/* 1040px is where the site swaps the nav bar for the hamburger menu, so the
   hero switches to its stacked mobile CTAs at the same breakpoint. */
.mobile-only {
  display: none;
}

.non-mobile-only {
  display: none;
}

@media (min-width: 1041px) {
  .non-mobile-only {
    display: block;
  }
}

@media (max-width: 1040px) {
  .mobile-only {
    display: block;
  }

  /* One primary action, one secondary, and quiet text links for the rest. */
  .hero-buttons {
    flex-direction: column;
    align-items: center;
    gap: 14px;
  }

  .demo-button,
  .signup-button {
    width: 100%;
    max-width: 300px;
  }

  .demo-button a,
  .signup-button a {
    display: block;
    width: 100%;
    text-align: center;
    padding: 14px 20px;
    font-size: 17px;
  }

  .signup-button a {
    background: transparent;
    border: 2px solid #f75023;
    border-radius: 50px;
    color: #f75023;
    font-family: 'Jost', sans-serif;
    font-weight: 600;
    text-decoration: none;
    box-shadow: none;
  }

  .signup-button a span {
    color: #f75023;
  }

  .hero-secondary {
    align-items: stretch;
    margin-top: 4px;
    gap: 14px;
  }

  /* The video and login links stop competing with the buttons above them. */
  .video-button {
    display: flex;
  }

  .video-button a {
    display: flex;
    align-items: center;
    gap: 6px;
    border: none;
    border-radius: 0;
    padding: 6px 0;
    color: #1cbe59;
    font-size: 16px;
    line-height: 1.3;
    font-weight: 600;
  }

  .video-button a span {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .video-button a:before {
    content: none;
  }

  .video-button a span,
  .video-button a:hover span {
    color: #1cbe59;
  }

  .video-button img {
    width: 20px;
    vertical-align: text-bottom;
  }

  .login-link {
    display: flex;
    align-items: center;
    padding: 6px 0 6px 14px;
    border-left: 1px solid rgba(0, 0, 0, 0.15);
    color: #444;
    font-family: 'Jost', sans-serif;
    font-size: 16px;
    line-height: 1.3;
    font-weight: 500;
    text-decoration: none;
  }

  body.dark .login-link {
    border-left-color: rgba(255, 255, 255, 0.2);
    color: #ccc;
  }
}
</style>